import React from 'react';
import { CssVarsProvider } from '@mui/joy/styles';
import CssBaseline from '@mui/joy/CssBaseline';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import CreateExam from './pages/CreateExam';
import EditExam from './pages/EditExam';
import EditSection from './pages/EditSection';
import EditQuestion from './pages/EditQuestion';
import ManageExamSections from './pages/ManageExamSections';
import ExamDetails from './pages/ExamDetails';
import Proctoring from './pages/Proctoring';
import Instructions from './pages/Instructions';
import WriteExam from './pages/WriteExam';
import ThankYou from './pages/ThankYou';

function App() {
  return (
    <CssVarsProvider>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          {/* Student Exam Flow */}
          <Route path="/exam/:examId/:registrationHash" element={<ExamDetails />} />
          <Route path="/exam/proctoring/:examId/:registrationHash" element={<Proctoring />} />
          <Route path="/exam/instructions/:examId/:registrationHash" element={<Instructions />} />
          <Route path="/exam/writeexam/:examId/:registrationHash" element={<WriteExam />} />
          <Route path="/exam/thankyou" element={<ThankYou />} />

          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/exams/new" element={<CreateExam />} />
          <Route path="/admin/exams/:id" element={<EditExam />} />
          <Route path="/admin/sections/new" element={<EditSection />} />
          <Route path="/admin/sections/:id" element={<EditSection />} />
          <Route path="/admin/questions/new" element={<EditQuestion />} />
          <Route path="/admin/questions/:id" element={<EditQuestion />} />
          <Route path="/admin/exams/:examId/sections" element={<ManageExamSections />} />

          {/* Redirect all other routes to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </CssVarsProvider>
  );
}

export default App;
